export default class UnitFactory {
  create() {
    return {
      id: null,
      name: '',
      address: '',
      address_short: '',
      location_id: null,
      neighbours: [],
      window_ratio: 63,
      window_ratio2: 30,
    }
  }
}
